globalThis.backoffice = globalThis.backoffice || {};

$(function () {
  backoffice.env = {
    DEV: $('body').hasClass("dev-env")
  }

  // Switchery toggles
  var $switcheries = $('.checkbox-switchery');
  $switcheries.each(function () {
    var $this = $(this);
    var $input = $(this).find('input[type=checkbox]');
    var config = {
      className: "switchery switchery-small"
    }

    if ($input.hasClass('switchery-primary')) {
      config.color = "#2196F3";
    } else if ($input.hasClass('switchery-danger')) {
      config.color = "#EF5350";
    } else if ($input.hasClass('switchery-warning')) {
      config.color = "#FF7043";
    }

    new Switchery($input[0], config);

    if ($this.data("toggle-target") !== undefined) {
      var $target = $("#" + $this.data("toggle-target"));
      if ($target) {
        $input.on('change', function () {
          if ($input.prop("checked")) {
            $target.show();
          } else {
            $target.hide();
          }
        });
      }
    }
  });

  $("body").on("click", ".collapse-control", function () {
    var $control = $(this);
    var $target = $($control.data("collapse"));
    if ($target.length > 0) {
      $target.toggle();
    }
  })

  backoffice.screenshotUpdater = new backoffice.ScreenshotUpdater();
  backoffice.attachedFilesUploader = new backoffice.AttachedFilesUploader($('#upload-attached-files'));
  backoffice.globalSearch = new backoffice.GlobalSearch($('#global-search'));
  //backoffice.notifications = new backoffice.Notifications($('#notifications-container'));
  backoffice.comments = new backoffice.Comments();
  backoffice.contacts = new backoffice.Contacts();
  backoffice.decryption = new backoffice.Decryption();
  backoffice.imageModalOpener = new ImageModalOpener();
  SearchFilter.initFilters($('input.filter'));
  FormAutosave.initForms($('.form-autosave'));
  ContainersToggler.init();
  ColorPreviewer.init();
  ValueSwitcher.init();
  PasswordToggler.init();
  EmojiPicker.init();

  backoffice.websiteMigrationStatusesUpdater = new backoffice.WebsiteMigrationStatusesUpdater($('.scrapping-statuses'));

  backoffice.CustomerPulse.init();

  backoffice.loader = new backoffice.Loader();
  backoffice.loader.init();

  globalThis.ModalOpener.initModalOpeners();

  $('.tasks-project').on('change', 'li input[type=checkbox]', function () {
    var $this = $(this),
      $task_item = $this.closest('li'),
      $form = $this.closest('form'),
      state = $this.prop('checked');

    if (confirm("Mettre à jour cette étape")) {
      $.ajax({
        url: $form.attr('action'),
        method: $form.attr('method'),
        data: $form.serialize(),
        success: function (data) {
          if (data.response) {
            $updated_task_item = $(data.task_item)
            $updated_task_item.find('[data-popup="tooltip"]').tooltip();
            $input = $updated_task_item.find('input')
            if ($input.is(':checked')) {
              $input.uniform({
                radioClass: 'choice',
                wrapperClass: 'border-success-600 text-success-800'
              });
            } else {
              $input.uniform({
                radioClass: 'choice',
                wrapperClass: 'border-default text-default'
              });
            }
            if ($task_item.data('reload-page-after-update')) {
              window.location.reload();
            } else {
              $task_item.replaceWith($updated_task_item);
            }
          }
        },
        error: function (data) {

        }
      })
    } else {
      $this.prop('checked', state);
      return false;
    }
  });

  // Clipboard
  var clipboards = new Clipboard('.clipboard');

  clipboards.on('success', function (e) {
    $(e.trigger).attr('data-original-title', 'Copié !').tooltip('show').blur();
  }).on('error', function (e) {
    $(e.trigger).attr('data-original-title', 'Erreur de copie...').tooltip('show').blur();
  });

  $('body').on('click', '.email-model-previewer', function (e) {
    e.preventDefault();
    backoffice.EmailModelPreviewer.preview($(this));
  });

  $('textarea.ck-editor').each(function () {
    var $textarea = $(this);

    utils.require([assets.ckeditor], function () {
      var targetId = $textarea.attr('id'),
        editorParams = {
          startupFocus: false,
          enterMode: CKEDITOR.ENTER_BR,
          height: 80,
          skin: 'moono-lisa',
          removePlugins: 'font',
          extraPlugins: 'autogrow,sourcedialog',
          autoGrow_onStartup: true,
        };

      if ($textarea.data('allowed-content') != undefined) {
        editorParams["allowedContent"] = $textarea.data('allowed-content')
      }

      var editor = CKEDITOR.replace(targetId, editorParams);
      editor.on('instanceReady', function (ev) {
        ev.editor.dataProcessor.writer.setRules('br', {
          indent: false,
          breakBeforeOpen: false,
          breakAfterOpen: false,
          breakBeforeClose: false,
          breakAfterClose: false
        });
      });
    });
  });

  $('[data-popup="lightbox"]').fancybox({
    padding: 3
  });

  $('[data-popup="tooltip"]').tooltip();
  $('.has-popover').popover({ html: true });

  if ($('body').hasClass('no-backward')) {
    // Disabled back button for most popular web browser
    window.history.pushState(null, "", window.location.href);
    window.onpopstate = function () {
      window.history.pushState(null, "", window.location.href);
    };
  }

  $('.text-area-fit-content').each(function () {
    $(this)[0].style.height = 'auto';
    $(this)[0].style.height = ($(this)[0].scrollHeight) + 'px';

    $(this).on('input', function (e) {
      $(this)[0].style.height = 'auto';
      $(this)[0].style.height = ($(this)[0].scrollHeight) + 'px';
    });
  });

});
